import { useAuth } from "../contexts/AuthContext";

function Logout() {
    const { logout } = useAuth();
    logout();
    window.location.replace(`${process.env.REACT_APP_DEPLOY_PATH}/login`);
    return null;
}

export default Logout;